import React from 'react'

const BlogContext = React.createContext()
const {
  Consumer,
  Provider
} = BlogContext

export {
 Consumer as BlogPosts
}

export const withBlogPosts = WrappedComponent => props => 
  <Consumer>
    {ctx => 
      <WrappedComponent {...ctx} {...props} />
    }
  </Consumer>

export default class BlogProvider extends React.Component {
  state = {
    posts: [],
    slug: ''
  }
  componentDidMount() {
    this.inflate()
  }
  inflate() {
    if (typeof window !== 'undefined') {
      this.setState(state => {
        if (window.__PRELOADED_STATE__.blogPosts || window.__PRELOADED_STATE__.slug) {
          return {
            ...window.__PRELOADED_STATE__.blogPosts && {
              posts: window.__PRELOADED_STATE__.blogPosts
            },
            ...window.__PRELOADED_STATE__.slug && {
              slug: window.__PRELOADED_STATE__.slug
            }
          }
        }
        return null
      })
    }
  }
  fetchAll = () => {
    if (typeof window !== 'undefined') {
      // fired from client, query BE
      fetch('/blog', {
        headers: new Headers({ 'from-client': 'true' })
      })
        .then(r => r.json())
        .then(posts => this.setState({ posts }))
        .catch(e => console.error(e))
    }
  }
  fetchSingle = (slug) => {
    if (typeof window !== 'undefined') {
      // in client, check if there are posts matching the slug, if there is - return
      const filteredPosts = this.state.posts
        .filter(post => post.fields.slug === slug)
      if (filteredPosts.length > 0) {
        this.setState({ slug })
        return
      }
    }
    fetch(`/blog/${slug}`, {
      headers: new Headers({ 'from-client': 'true' })
    })
      .then(r => r.json())
      .then(post => {
        this.setState({
          posts: [
            ...this.state.posts.filter(post => post.fields.slug !== slug),
            ...post
          ],
          slug
        })
      })
      .catch(e => e)
  }
  getContextValues = () => ({
    blog: {
      posts: this.props.blogPosts || this.state.posts,
      slug: this.props.slug || this.state.slug,
      actions: {
        fetchAll: this.fetchAll,
        fetchSingle: this.fetchSingle
      }
    }
  })
  render() {
    return (
      <Provider value={this.getContextValues()}>
        {this.props.children}
      </Provider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/providers/Blog.js